import * as usersAPI from 'lib/api/service/users';
import {
  changeInviteInputs,
  initializeInviteInputs,
} from 'modules/serviceSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useEffect, useState } from 'react';
import { validateInviteUserForm } from 'utils/validate';
import useLoginCheck from 'hooks/common/useLoginCheck';

const useInviteModal = (title, closeModal, setServerError) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const [isSubmit, setIsSubmit] = useState(false);
  const [errors, setErrors] = useState({});
  const level = title === '주니어 관리자' ? '3' : '2';

  const { email, name, store, storeId } = useSelector(
    ({ service }) => service.inviteInputs,
  );

  const storeListRes = useQuery('storeList', usersAPI.getStoreList);
  useLoginCheck(storeListRes.error?.response, storeListRes.refetch);
  const storeList = storeListRes?.data?.data.list;
  const filteredStoreList = storeList?.filter(el => el.store.includes(store));

  const inviteUser = useMutation(usersAPI.inviteUser, {
    onError: error => {
      if (error.response.data.error === 'AlreadyInviteUserExist') {
        setServerError(error.response.data.msg);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('users');
    },
  });
  useLoginCheck(inviteUser.error?.response, () => {
    inviteUser.mutate({
      email: inviteUser.variables?.email,
      name: inviteUser.variables?.name,
      level,
      storeId: inviteUser.variables?.storeId,
    });
  });

  useEffect(() => {
    return () => {
      dispatch(initializeInviteInputs());
    };
  }, [dispatch]);

  useEffect(() => {
    if (isSubmit && Object.keys(errors).length === 0) {
      dispatch(initializeInviteInputs());
      inviteUser.mutate({
        email,
        name,
        level,
        storeId: String(storeId),
      });
      setIsSubmit(false);
    }
  }, [errors, isSubmit, dispatch, email, inviteUser, name, storeId, level]);

  useEffect(() => {
    if (inviteUser.isSuccess) {
      closeModal();
    }
  }, [inviteUser.isSuccess, closeModal]);

  const onChange = e => {
    const { name, value } = e.target;
    dispatch(changeInviteInputs({ key: name, value }));
  };

  const onClick = (store, storeId) => {
    dispatch(changeInviteInputs({ key: 'store', value: store }));
    dispatch(changeInviteInputs({ key: 'storeId', value: storeId }));
  };

  const onSubmit = e => {
    e.preventDefault();
    setErrors(validateInviteUserForm(store, name, email));
    setIsSubmit(true);
  };

  return {
    email,
    name,
    store,
    storeList,
    onChange,
    onClick,
    onSubmit,
    filteredStoreList,
    inviteUser,
    errors,
  };
};

export default useInviteModal;
